import { render, staticRenderFns } from "./RuleInfo.vue?vue&type=template&id=cd509bf6&scoped=true&"
import script from "./RuleInfo.vue?vue&type=script&lang=js&"
export * from "./RuleInfo.vue?vue&type=script&lang=js&"
import style0 from "./RuleInfo.vue?vue&type=style&index=0&id=cd509bf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd509bf6",
  null
  
)

export default component.exports